import WorkCard from "@/components/base/WorkCard";
import EmptyState from "@/components/base/EmptyState";
import type { Work } from "@/types/film";

interface WorkGridProps {
  works: Work[];
  emptyTitle?: string;
  emptyDescription?: string;
}

export default function WorkGrid({
  works,
  emptyTitle = "当前暂无推荐内容",
  emptyDescription = "换个条件或稍后再来看看吧。",
}: WorkGridProps) {
  if (!works.length) {
    return <EmptyState icon="ri-movie-line" title={emptyTitle} description={emptyDescription} />;
  }

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
      {works.map((work) => (
        <WorkCard key={work.id} work={work} />
      ))}
    </div>
  );
}